import React from 'react';
import { AnnotationToolbarWrap, ToolbarButtons, ToolbarBtn, Tooltip } from './Annotation.styles';
import { ANNOTATION_CATEGORIES } from './AnnotationIcons';
import AnnotationPanel from './AnnotationPanel';
import DrawingToolsPanel from './DrawingToolsPanel';

// Drawing Tools icon (pencil/draw)
const DrawingToolsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
  </svg>
);

const AnnotationToolbar = ({
  activeCategory,
  pendingType,
  routeDrawing,
  drawingPanelOpen,
  activeTool,
  showDrawingTools,
  onCategoryClick,
  onSelectIcon,
  onClosePanel,
  onToggleDrawingPanel,
  onSelectDrawingTool,
}) => {
  return (
    <AnnotationToolbarWrap>
      {/* Drawing Tools panel — only when drawing tools are enabled */}
      {showDrawingTools && drawingPanelOpen && (
        <DrawingToolsPanel
          activeTool={activeTool}
          onSelectTool={onSelectDrawingTool}
          onClose={onClosePanel}
        />
      )}

      {/* Annotation category panel */}
      {!drawingPanelOpen && activeCategory && (
        <AnnotationPanel
          activeCategory={activeCategory}
          pendingType={pendingType}
          onSelectIcon={onSelectIcon}
          onClose={onClosePanel}
        />
      )}

      <ToolbarButtons>
        {/* Drawing Tools button — always visible */}
        <ToolbarBtn
          active={drawingPanelOpen || routeDrawing}
          onClick={onToggleDrawingPanel}
          title="Drawing Tools"
        >
          <DrawingToolsIcon />
          <Tooltip className="toolbar-tooltip">Drawing Tools</Tooltip>
        </ToolbarBtn>

        {/* Divider */}
        <div style={{ height: 1, background: '#e5e7eb', margin: '2px 0' }} />

        {/* Category buttons */}
        {ANNOTATION_CATEGORIES.map(cat => (
          <ToolbarBtn
            key={cat.key}
            active={activeCategory === cat.key}
            onClick={() => onCategoryClick(cat.key)}
            title={cat.label}
          >
            {/* Safe: toolbarSvg is a static string from ANNOTATION_CATEGORIES, never from user input */}
            <span
              dangerouslySetInnerHTML={{ __html: cat.toolbarSvg }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22 }}
            />
            <Tooltip className="toolbar-tooltip">{cat.label}</Tooltip>
          </ToolbarBtn>
        ))}
      </ToolbarButtons>
    </AnnotationToolbarWrap>
  );
};

export default AnnotationToolbar;
